import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router";
import { xOAuthCallbackDestination } from "../api/x-oauth-callback";

export function XOAuthCallbackPage() {
  const { search } = useLocation();
  const forwarded = useRef(false);
  const demo = import.meta.env.VITE_APP_MODE === "DEMO";
  const destination = demo ? null : xOAuthCallbackDestination(search,
    import.meta.env.VITE_API_BASE_URL?.trim() || "/api", window.location.origin);
  useEffect(() => {
    // Remove one-time credentials before any navigation, including malformed or
    // demo callbacks. Keep Router history state; StrictMode must not exchange twice.
    window.history.replaceState(window.history.state, "", "/x/oauth/callback");
    if (!destination || forwarded.current) return;
    forwarded.current = true;
    window.location.replace(destination);
  }, [destination]);
  return <main id="main-content" aria-label="X authorization" tabIndex={-1}>
    <h1>X authorization</h1>
    <p role="status">{demo ? "X authorization is unavailable in demo mode." : destination ?
      "Completing X authorization. The backend will return you to tasks." :
      "This callback is incomplete or unavailable. Return to tasks and start Login X again."}</p>
    <Link to="/tasks">Return to tasks</Link>
  </main>;
}
